import Vue from 'vue';
import BrowserDetails from './BrowserDetails/BrowserDetails';
import ExcludeDevices from './ExcludeDevices/ExcludeDevices';
import KeepValue from './KeepValue/KeepValue';
import RecordClicks from './RecordClicks/RecordClicks';
import ReportIssues from './ReportIssues';
import RoundRobin from './RoundRobin/RoundRobin';
import ScreenSize from './ScreenSize/ScreenSize';
import SelectRandomValues from './SelectRandomValues/SelectRandomValues';
import Slider from './Slider';
import UniqueIdentifier from './UniqueIdentifier/UniqueIdentifier';
import YoutubeVideo from './YoutubeVideo/YoutubeVideo';
import TrialComments from './TrialComments';
import QR from './QR';
import NoFeedback from './NoFeedback';
import $ from 'jquery';
import {Modal} from 'bootstrap-vue/es/components';
import Random from './RandomOptions/Random';
import SaveOrder from './RandomOptions/SaveOrder';

Vue.use(Modal);

const materials = [
  {
    selector: 'browser-details',
    component: BrowserDetails,
    props: ['target']
  },
  {
    selector: 'exclude-devices',
    component: ExcludeDevices,
    props: ['mobile', 'tablet', 'show-other-questions']
  },
  {
    selector: 'keep-value',
    component: KeepValue,
    props: ['variable', 'random', 'min', 'max', 'trial']
  },
  {
    selector: 'qr',
    component: QR,
    props: []
  },
  {
    selector: 'no-feedback',
    component: NoFeedback,
    props: ['label']
  },
  {
    selector: 'record-clicks',
    component: RecordClicks,
    props: ['save-to', 'inner-html', 'target', 'href']
  },
  {
    selector: 'report-issues',
    component: ReportIssues,
    props: ['survey', 'treatment']
  },
  {
    selector: 'round-robin',
    component: RoundRobin,
    props: ['target', 'trial', 'values', 'submit-on-ready']
  },
  {
    selector: 'screen-size',
    component: ScreenSize,
    props: ['target']
  },
  {
    selector: 'select-random-values',
    component: SelectRandomValues,
    props: ['values', 'save-to']
  },
  {
    selector: 'slider',
    component: Slider,
    props: ['interval', 'min', 'max', 'default', 'tooltip-fn', 'tooltip-prefix', 'tooltip-suffix', 'min-text', 'max-text', 'target']
  },
  {
    selector: 'trial-comments',
    component: TrialComments,
    props: ['server', 'survey', 'treatment']
  },
  {
    selector: 'unique-identifier',
    component: UniqueIdentifier,
    props: ['length', 'trial']
  },
  {
    selector: 'youtube-video',
    component: YoutubeVideo,
    props: ['data-height', 'data-video', 'data-width']
  },
];

$(function () {
  materials.forEach(material => {
    $(`[data-vue-materials='${material.selector}']`).map(function () {
      const jqueryElm = $(this);
      const el = jqueryElm.get(0);
      const ComponentClass = Vue.extend(material.component);
      const props = {};
      if (material.props)
        material.props.forEach(prop => {
          if (prop === 'inner-html') {
            props[prop] = {default: jqueryElm.html()};
            return;
          }

          const value = jqueryElm.attr(prop);
          if (typeof value !== 'undefined')
            props[prop] = {default: value};
        });
      const instance = new ComponentClass({
        props
      });
      instance.$mount(el);
    });
  });
});

/* RandomOptions */
const components = {
  Random,
  SaveOrder
};

if (!window.vueAppRandomiseOptionsLoaded) {
  document.addEventListener('DOMContentLoaded', function () {
    [].forEach.call(document.getElementsByClassName('vue-app-randomise-options'), el => {

      console.log({vueAppRandomiseOptions: el});
      new Vue({
        components
      }).$mount(el);
    });
  }, false);

  window.vueAppRandomiseOptionsLoaded = true;
}
